import { ConfinusUI__Tables__DataTableRowControllerIdentifier } from "controllers/identifiers";
import BaseController from "confinus_ui/base_controller";
import DataTableRowController from "confinus_ui/tables/data_table_row_controller";

export default class ModifyOrderFormController extends BaseController {
  public static outlets = [
    ConfinusUI__Tables__DataTableRowControllerIdentifier,
  ];
  declare private readonly confinusUiTablesDataTableRowOutlets: DataTableRowController[];
  private get rowControllers() {
    return this.confinusUiTablesDataTableRowOutlets;
  }

  public toggleDisableRow(evt: CustomEvent<{ rowId: string }>) {
    const { rowId } = evt.detail;
    const rowToToggle = this.rowControllers.find((rc) => rc.id === rowId);
    if (rowToToggle) {
      rowToToggle.disabled = !rowToToggle.disabled;
    }
  }
}
